import React from 'react';
import { smallGalleryImagesArray } from '../../utils/data/GalleryData';

function SmallGalleryComponent() {
  return (
    <section className='grid lg:px-16'>
      <div className='grid grid-cols-2 grid-rows-4 h-screen md:max-h-[80vh] lg:max-h-[60vh] md:grid-cols-4 md:grid-rows-2 shadow-cardShadowBold shadow-colour4/80'>
        {smallGalleryImagesArray.map((image) => (
          <div
            key={image.id}
            className='relative w-full h-full overflow-hidden group'
          >
            <img
              src={image.src}
              alt={image.alt}
              aria-label={image.ariaLabel}
              className='w-full h-full object-cover object-[center_20%] transition-transform duration-500 group-hover:scale-110 group-hover:filter-none filter brightness-75'
              loading='lazy'
            />
          </div>
        ))}
      </div>
    </section>
  );
}

export default SmallGalleryComponent;
